import { createSelector } from 'reselect';
import moment from 'moment';
import * as constants from './constants';
/**
 * Direct selector to the domain's state
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
//----------------------------------------------------------------------------------------------------------------------
/**
 * Chart mode
 */ export const mode = (state)=>mainSelector(state).mode;
/**
 * Chart device mode
 */ export const deviceMode = (state)=>{
    var _mainSelector;
    return (_mainSelector = mainSelector(state)) === null || _mainSelector === void 0 ? void 0 : _mainSelector.deviceMode;
};
/**
 * Calculation formula for aggregation
 */ export const calculationFormula = (state)=>mainSelector(state).calculationFormula;
/**
 * Time unit for aggregation
 */ export const aggregateBy = (state)=>mainSelector(state).aggregateBy;
/**
 * Type of grouping
 */ export const groupBy = (state)=>mainSelector(state).groupBy;
/**
 * Import document ids that are loaded on chart
 */ export const fromImports = (state)=>mainSelector(state).fromImports;
/**
 * Min and max readings timestamps for selected imports
 */ export const fromImportsRange = (state)=>mainSelector(state).fromImportsRange;
/**
 * Selects if trend chart line is enabled
 */ export const isTrendChartLineEnabled = (state)=>mainSelector(state).isTrendChartLineEnabled;
/**
 * Selects if CGM goals are visible
 */ export const showCGMGoals = (state)=>mainSelector(state).showCGMGoals;
/**
 * Selects if GCL tight range is visible
 */ export const showTightRange = (state)=>mainSelector(state).showTightRange;
/**
 * Layout of dashboard widgets
 */ export const dashboardLayout = (state)=>mainSelector(state).dashboardLayout;
/**
 * Is results fetching
 */ export const resultsIsInProgress = (state)=>{
    var _mainSelector;
    return (_mainSelector = mainSelector(state)) === null || _mainSelector === void 0 ? void 0 : _mainSelector.resultsIsInProgress;
};
//----------------------------------------------------------------------------------------------------------------------
/**
 * Reports state
 */ export const reportsState = (state)=>mainSelector(state).reportsState;
/**
 * Reports state MedicalRecord
 */ export const reportsStateMedicalRecord = (state)=>{
    var _reportsState;
    return (_reportsState = reportsState(state)) === null || _reportsState === void 0 ? void 0 : _reportsState.accountPatientProfile;
};
/**
 * Reports state PhiSet
 */ export const reportsStatePhiSet = (state)=>{
    var _reportsState;
    return (_reportsState = reportsState(state)) === null || _reportsState === void 0 ? void 0 : _reportsState.phiSet;
};
/**
 * Reports state Readings
 */ export const reportsStateReadings = (state)=>{
    var _reportsState;
    return (_reportsState = reportsState(state)) === null || _reportsState === void 0 ? void 0 : _reportsState.readings;
};
/**
 * Reports state RelatedData
 */ export const reportsStateRelatedData = (state)=>{
    var _reportsState;
    return (_reportsState = reportsState(state)) === null || _reportsState === void 0 ? void 0 : _reportsState.relatedData;
};
/**
 * Reports state TimeSeriesResources
 */ export const reportsStateTimeSeriesResources = (state)=>{
    var _reportsState;
    return (_reportsState = reportsState(state)) === null || _reportsState === void 0 ? void 0 : _reportsState.timeSeriesResources;
};
//----------------------------------------------------------------------------------------------------------------------
/**
 * Report types to be rendered on reports page
 */ export const reportTypes = (state)=>mainSelector(state).reportTypes;
export const gestationalReportSettingsSelector = (state)=>mainSelector(state).gestationalReportSettings;
export const standardsSelector = (state)=>reportsState(state).standards;
export const selectedReading = (state)=>mainSelector(state).selectedReading;
/**
 * Active patient blood glucose readings
 */ export const readings = (state)=>reportsState(state).readings;
export const readingsRangeDate = createSelector(readings, (readingsState)=>(daysEndOffset, daysBeforeEndOffset = 30)=>{
        const lastPossibleMoment = moment.utc().add(-daysEndOffset, 'days').endOf('day').locale('en--account');
        const firstPossibleMoment = lastPossibleMoment.clone().add(-(daysBeforeEndOffset - 1), 'days').startOf('day');
        const firstPossibleTimestamp = firstPossibleMoment.unix();
        const lastPossibleTimestamp = lastPossibleMoment.unix();
        return readingsState.filter((reading)=>reading.timestamp > firstPossibleTimestamp && reading.timestamp < lastPossibleTimestamp);
    });
export const imbPatterns = (state)=>mainSelector(state).imbPatterns;
